import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import IndividualPrintsBuilder from '../../PackageBuilders/IndividualPrintsBuilder';
import useOrderPackage from '../../../hooks/useOrderPackage';
import AddonSheetBuilder from '../../PackageBuilders/AddonSheets';
import routes from '../../../routes';
import styles from './Addons.module.scss';
import usePoses from '../../../hooks/usePoses';
import useRetouchingExtra from "../../../hooks/useRetouchingExtra";

export default function Addons() {
  const { orderPackageId } = useParams();
  const history = useHistory();
  const [step, setStep] = useState(0);

  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { data: poses } = usePoses(orderPackage?.studentId, orderPackage?.packageId);
  const { data: retouching, isLoading: isLoadingRetouching } = useRetouchingExtra();

  if (!orderPackage) return null;

  const { background, pose } = orderPackage.sheets[0];

  const redirectUrl = () => {
    //if (retouching) return routes.retouching(orderPackageId)

    return routes.confirm(orderPackageId);
  }

  const {
    cartId,
    packageId,
    optionId,
    student: {
      schoolId,
    },
  } = orderPackage;

  if (!poses || isLoadingRetouching) return null;

  return (
    <>
      <h1 className={styles.header}>Customize your Package w/ Individual Addons</h1>
      {step === 0 && (
        <IndividualPrintsBuilder
          useRetouching
          background={background}
          pose={pose}
          poses={poses}
          cartId={cartId}
          optionId={optionId}
          schoolId={schoolId}
          packageId={packageId}
          orderPackage={orderPackage}
          onSave={() => setStep(1)}
          onCancelProps={{ onClick: () => history.push(redirectUrl()) }}
        />
      )}
      {step === 1 && (
        <AddonSheetBuilder
          orderPackageId={orderPackage.id}
          onSave={() => history.push(redirectUrl())}
        />
      )}
    </>
  );
}
